<template>
  <div v-loading="loading" class="rj-page-card">
    <div class="rj-page-card__title">
      合同基本信息
    </div>
    <div class="rj-page-card__content">
      <el-form ref="form" :model="form" class="baseInfoForm">
        <div class="rj-row">
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                订单日期：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.rcreatedTime }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                原合同编号：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.roldContractNum }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                电子商务合同编号：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.rnewContractNum }}
              </div>
            </div>
          </div>
          <!-- 供货单位甲方 -->
          <supply-unit
            ref="supplyUnit"
            v-model="form"
            required
            @changesupply="changeSupply"
          />
          <!-- <ordering-unit v-model="form" required :is-select="(isDirectOrder || isSaleBorrowing)" @changeOrderUnit="changeOrderUnit" :enable-change="enableChangeorderingUnit" /> -->
          <div class="rj-col-66">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                订货单位(乙方)：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.rorderUnitName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                订货单位电话(乙方)：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="supplyPhone">
                  <el-input v-model="form.rorderUnitTel" />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-66">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                最终客户：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.rfinalCustomerName }}
              </div>
            </div>
          </div>
          <!-- <end-customer v-model="form" required @changeEndUnit="changeEndUnit" /> -->
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                客户签约类型：
              </div>
              <div class="rj-baseinfo__item">
                <!-- {{ form.rorderType }} -->
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                订单分类：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.rorderType }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                场景分类：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.rScenarioCategory }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                币种：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.rcurrencyType ? form.rcurrencyType : "CNY" }}
              </div>
            </div>
          </div>
          <!-- <tax-type v-model="form" required @changeTaxType="changeTaxType" /> -->
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                净销售额：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="rnetSales">
                  <el-input
                    v-model="form.rnetSales"
                    placeholder="请输入净销售额"
                  />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                现销或赊销：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="salesType">
                  <el-radio-group v-model="form.rsalesSettlementModes" disabled>
                    <el-radio
                      v-for="(type, index) in salesType"
                      :key="index"
                      :label="type.code"
                    >
                      {{ type.name }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </div>
          </div>
          <account-period v-model="form" />
          <!-- <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">账期：</div>
              <div class="rj-baseinfo__item">
                {{ form.raccountPeriod }}
              </div>
            </div>
          </div> -->
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                付款方式：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="paymentMethod">
                  <el-select
                    v-model="form.paymentMethod"
                    placeholder="请选择付款方式"
                  >
                    <el-option
                      v-for="item in paymentMethod"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-66">
            <order-type ref="orderType" v-model="form" required />
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                售前名称：
              </div>
              <div class="rj-baseinfo__item">
                <div class="rj-baseinfo__item">
                  {{ form.rpreSalesPersonName }}
                </div>
                <!--{{ form.netSales }}-->
              </div>
            </div>
          </div>
          <!-- <pre-sale v-model="form" required ref="preSale" />
          <export-sale v-model="form" required ref="exportSale" /> -->
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                外销名称：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.rsalesPersonName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                部门：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.rsalesPersonDeptName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                区域：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.rsalesArea }}
              </div>
            </div>
          </div>
          <!-- <region-auto v-model="form" ref="regionAuto" /> -->
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                项目代码(CRM编号)：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.rcrmCode }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                项目名称：
              </div>
              <div class="rj-baseinfo__item">
                <div class="rj-baseinfo__item">
                  {{ form.rprojectName }}
                </div>
              </div>
            </div>
          </div>
          <region-business ref="regionBusiness" v-model="form" />
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                首级集成商名称：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.rintegratorName || "无" }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                首级集成商类型：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.rintegratorSignType || "无" }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                计量客户：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.metrologyIntegratorName || "无" }}
              </div>
            </div>
          </div>
          <!-- <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">计量集成商类型：</div>
              <div class="rj-baseinfo__item">
                {{ form.rintegratorSignType || '无' }}
              </div>
            </div>
          </div> -->

          <!-- <market v-model="form" ref="market" /> -->
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                细分市场：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.rmarketSegmentName || "无" }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                应用场合：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.rapplicationScenariosName || "无" }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                应用场景：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.rapplicationSceneName || "无" }}
              </div>
            </div>
          </div>
          <div class="rj-col-66">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                CRM客户编码：
              </div>
              <div class="rj-baseinfo__item">
                <!-- {{ form.rapplicationSceneName || '无' }} -->
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                发货方式<span class="required">*</span>：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="shipType">
                  <el-radio-group v-model="form.rdeliveryMethod">
                    <el-radio
                      v-for="(type, index) in shipTypeList"
                      :key="index"
                      :label="type.code"
                    >
                      {{ type.name }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </div>
          </div>

          <!-- <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">特价标志：</div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="isSpecialPrice">
                  <el-checkbox v-model="form.isSpecialPrice" />
                </el-form-item>
              </div>
            </div>
          </div> -->
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                计量计点：
              </div>
              <div class="rj-baseinfo__item">
                {{
                  $store.getters["enumeration/getmeteringPoint"](
                    form.rmeteringPoint
                  )
                }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                齐套通知打款邮箱<span
                  v-if="!(isDirectOrder || isSaleBorrowing)"
                  class="required"
                >*</span>
                ：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="rsetNoticeMail">
                  <el-input
                    v-model="form.rsetNoticeMail"
                    placeholder="请输入齐套通知打款邮箱"
                    :readonly="
                      !(this.email
                        ? false
                        : true || isDirectOrder || isSaleBorrowing)
                    "
                  />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                授权邮箱：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="rauthEmail">
                  <el-input
                    v-model="form.rauthEmail"
                    placeholder="请输入授权邮箱"
                  />
                </el-form-item>
              </div>
            </div>
          </div>

          <payment-bank
            ref="bank"
            v-model="form"
            :contract-num="this.$route.query.rnewContractNum"
          />

          <div v-if="$route.query.contractType === '换货合同' " class="rj-col-1">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                是否使用返利：
              </div>
              <div class="rj-baseinfo__item">
                <div class="rj-baseinfo__item">
                  <el-radio-group v-model="form.risUseRebate" disabled>
                    <el-radio :label="1">
                      是
                    </el-radio>
                    <el-radio :label="0">
                      否
                    </el-radio>
                  </el-radio-group>
                  <span v-if="form.risUseRebate" class="ml-20">
                    使用金额: {{ form.ruseRebateAmount || 0 }} 元
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                已分配金额/比例：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.rassignedAmount }}元
                <template v-if="form.ractualSettlementAmount">
                  /
                  {{ setUsePayMoney(form) }}
                </template>
              </div>
            </div>
          </div>

          <div class="rj-col-1">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                是否使用返利<span class="required">*</span>：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item style="display: inline-block">
                  <el-radio-group v-model="form.risUseRebate" :disabled="true">
                    <el-radio :label="1">
                      是
                    </el-radio>
                    <el-radio :label="0">
                      否
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <template v-if="form.risUseRebate">
                  <span style="margin-left: 20px;">使用返利金额： {{ form.ruseRebateAmount }}</span>
                </template>
              </div>
            </div>
          </div>

          <div class="rj-col-1">
            <el-form-item prop="rsupplementalTerm" label="补充条款:">
              <el-input
                v-model.trim="form.rsupplementalTerm"
                type="textarea"
                :rows="3"
                placeholder="请输入补充条款"
                maxlength="200"
                show-word-limit
              />
            </el-form-item>
          </div>
          <div class="rj-col-1">
            <el-form-item prop="rserviceTerm" label="服务条款:">
              <el-input
                v-model.trim="form.rserviceTerm"
                type="textarea"
                :rows="3"
                placeholder="请输入服务条款"
                maxlength="200"
                show-word-limit
              />
            </el-form-item>
          </div>
          <div class="rj-col-1">
            <el-form-item
              prop="receiptArrivalAcceptanceRequirements"
              label="收货回执及到货验收要求:"
            >
              <el-input
                v-model.trim="form.rspecialRemarks"
                type="textarea"
                :rows="3"
                placeholder="请输入收货回执及到货验收要求"
                maxlength="200"
                show-word-limit
              />
            </el-form-item>
          </div>
          <div class="rj-col-1">
            <el-form-item prop="rrmarks" label="备注说明:">
              <el-input
                v-model.trim="form.rrmarks"
                type="textarea"
                :rows="3"
                placeholder="请输入备注说明"
                maxlength="200"
                show-word-limit
              />
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script type="es6">
import supplyUnit from './supplyUnit';
import { MathMulti, numDiv } from '@/libs/util';
// import EndCustomer from '../../../contractCommonInput/EndCustomer';
// import baseInfoMixin from './baseInfoMixin';
import { mapState } from 'vuex';
// const taxType = () => import('../../../contractCommonInput/taxType');
import {
  getEditRebateUsedList,
  getRebateSummaryAgentInfo,
  createContractNum
} from '@/API';
import rebateUse from '../../../Chief/contract/rabateUse.vue';
import rebateUsedList from '../../../Chief/contract/rebateUsedList.vue';
const orderType = () => import('./orderType');
const accountPeriod = () => import('./accountPeriod');
// const preSale = () => import('../../../contractCommonInput/preSale');
// const exportSale = () => import('../../../contractCommonInput/exportSale');
// const regionAuto = () => import('../../../contractCommonInput/regionAuto');
const regionBusiness = () => import('./regionBusiness');
// const market = () => import('../../../contractCommonInput/market');
const paymentBank = () => import('./paymentBank');
// import Collapse from '@/components/Collapse';
/* eslint-disable */
export default {
  // mixins: [baseInfoMixin],
  data () {
    var verifyEmail = (rule, value, callback) => {
      if (this.form.contractType === 'SMB分销下单' || this.form.contractType === '服务商分销下单' || this.isDirectOrder || this.isSaleBorrowing) {
        callback();
      } else {
        if (value === '') {
          callback(new Error('请输入齐套通知打款邮箱'));
        } else {
          callback();
        }
      }
    };
    var validateEmailAuthorization = (rule, value, callback) => {
      const mailReg = /^([a-zA-Z0-9]+[_|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[.|-]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,4}$/;
      if (!value) {
        callback();
      } else {
        if (this.form.authorizationEmail && this.form.authorizationEmail.length > 100) {
          callback(new Error('输入字符不能超过100'));
        } else if (!mailReg.test(value)) {
          callback(new Error('请输入正确的邮箱格式'));
        } else {
          callback();
        }
      }
    };
    var v = (rule, value, callback) => {
      if (value !== 1 && value !== 2) {
        callback(new Error('请选择发货方式!'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      paymentMethod: [{
        value: '立即',
        label: '立即付款'
      }],
      dialogNode: {
        is: '',
        allow: 123,//当前合同最大返利金额
        availableRebateAmount: 0,
        rebateUsedList: []
      },
      advanceCharge: '',
      prepaymentRatioNum: '',
      rules: {
        //   customerContractNum: [
        //     { required: true, message: '请输入客户合同编号', trigger: 'blur' }
        //   ],
        //   shipType: [
        //     { validator: shipTypeing, trigger: 'change' }
        //   ],
        //   // crmAccountCode: [
        //   //   { required: true, message: '请输入CCCCCC', trigger: 'blur' }
        //   // ],
        //   projectName: [
        //     { required: true, message: '请输入项目名称', trigger: 'blur' }
        //   ],
        //   supplyUnitId: [
        //     { required: true, message: '请选择供货单位', trigger: 'change' }
        //   ],
        //   orderUnitCode: [
        //     { required: true, message: '请选择订货单位', trigger: 'change' }
        //   ],
        //   finalCustomer: [
        //     { required: true, message: '请选择最终客户', trigger: 'change' }
        //   ],
        //   contractType: [
        //     { required: true, message: '请选择订单分类', trigger: 'change' }
        //   ],
        //   currencyId: [
        //     { required: true, message: '请选择币种', trigger: 'change' }
        //   ],
        //   preSalesCode: [
        //     { required: true, message: '请选择售前', trigger: 'change' }
        //   ],
        //   salesManCode: [
        //     { required: true, message: '请选择外销', trigger: 'change' }
        //   ],
        rsetNoticeMail: [
          // { required: true, pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/, message: '请输入正确的齐套通知打款邮箱', trigger: 'blur' }
          { validator: verifyEmail, trigger: 'blur' }
        ],
        saleTypeCode: [
          { required: true, message: '订单类型不能为空', trigger: 'change' }
        ],
        //   authorizationEmail: [
        //     { validator: validateEmailAuthorization, trigger: 'change' }
        //   ],
        //  regionBusinessCommissionerId: [{ required: true, message: '请选择区域商务专员', trigger: 'change' }]
      }
    };
  },
  model: {
    prop: 'form',
    event: 'change'
  },
  props: {
    form: {
      type: Object,
      default: () => { return {}; }
    },
    baseData: {
      type: Object,
      default: () => { return {}; }
    },

    email: {
      type: [String, Object],
      default: () => { return ''; }
    }

  },
  components: {
    // contractNumber,
    supplyUnit,
    // orderingUnit,
    // EndCustomer,
    orderType,
    accountPeriod,
    // preSale,
    // exportSale,
    // regionAuto,
    regionBusiness,
    // market,
    paymentBank,
    // taxType
    // rebateAmount
    rebateUse,
    rebateUsedList
  },
  computed: {
    ...mapState({
      moneyType: state => state.enumeration.moneyType,
      salesType: state => state.enumeration.salesType,
      // paymentMethod: state => state.enumeration.paymentMethod,
      shipTypeList: state => state.enumeration.shipType,
      EmbeddedSoftware: state => state.enumeration.EmbeddedSoftware,
      shanghaiHongkongDiscount: state => state.enumeration.shanghaiHongkongDiscount
    }),
    orderUnitDiscount () {
      let flag = false;
      if (this.form.orderUnit === '上海锐山网络有限公司' ||
        this.form.orderUnit === '上海爱伟迅数码科技有限公司' ||
        this.form.orderUnit === '星网锐捷（香港）有限公司' ||
        this.form.orderUnit === 'Ruijie Networks Communication Technology Industry and Trade Co., Ltd' ||
        this.form.orderUnit === 'Ruijie Malaysia Sdn. Bhd.' ||
        this.form.orderUnit === '福建省电子器材有限公司'
      ) {
        flag = true;
      }
      return flag;
    },
    enableChangeorderingUnit () {
      if (this.form.distributorParticipate || this.form.integratorParticipate) {
        return false;
      } else if (this.form.showNewContract) {
        return true;
      }
      return false;
    },
    // 是否是直签下单
    isDirectOrder () {
      if ((this.form.integratorParticipate === null || this.form.integratorParticipate === false) && (this.form.distributorParticipate === null || this.form.distributorParticipate === false)) {
        return true;
      }
      return false;
    },
    // 是否是销售借用下单
    isSaleBorrowing () {
      if (this.form.contractType === '销售借用下单') {
        return true;
      }
      return false;
    }
  },
  watch: {
    form (val) {
      this.form = val;
      this.dialogNode.allow = this.form.rorderMoney;
      // this.getEditRebateUsedList();
    },
  },
  methods: {
    changisRebate (val) {
      if (val === 2) {
        this.form.rebateAmount = 0;
        this.dialogNode.rebateUsedList = [];
      }
    },
    chooseRebateSuccess (val) {
      // 赋值过程toFixed();
      this.form.rebateAmount = val.total;
      this.dialogNode.rebateUsedList = val.list;
    },
    // 返利 接口
    getEditRebateUsedList () {
      getEditRebateUsedList({ contractNum: this.$route.query.rnewContractNum })
        // getEditRebateUsedList({ contractNum: '150221122800300' })
        .then((res) => {
          let json = res.data;
          if (json.status === '200') {
            if (json.data.length) {
              this.dialogNode.rebateUsedList = json.data;
              this.dialogNode.is = 'rebate-used-list';
            } else {
              this.dialogNode.is = 'rebate-use';
            }
          }
        })
        .catch(() => { });
      getRebateSummaryAgentInfo({ contractNum: this.$route.query.rnewContractNum })
        .then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.dialogNode.availableRebateAmount = json.data.availableAmount;
          }
        })
        .catch(() => { });
    },
    // 获取预付款金额比例接口
    getData(val){
      this.$refs.orderType.initContratOrderTypeNew(val);
    },
    setInitData () {
      this.$refs.supplyUnit.initData();
      if (this.$refs.exportSale) {
        this.$refs.exportSale.initData();
      }
      if (this.$refs.orderType) {
        this.$refs.orderType.initContratOrderType();
      }
      if (this.$refs.integrator) {
        this.$refs.integrator.initData();
      }
      if (this.$refs.market) {
        this.$refs.market.initData();
      }
      if (this.$refs.preSale) {
        this.$refs.preSale.initData();
      }
      if (this.$refs.regionAuto) {
        this.$refs.regionAuto.initData();
      }
      if (this.$refs.regionBusiness) {
        this.$refs.regionBusiness.initData();
      }
      if (this.$refs.bank) {
        this.$refs.bank.initData();
      }
    },
    changeSupply (val) {
      this.$refs.bank.searchBank({ 'id': val.id });
      createContractNum(val.unitAbbreviation, this.$route.query.contractType)
        .then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.form.rnewContractNum = json.data;
          }
        })
        .catch(() => { });
      // this.$refs.contractNumber.initData(val.unitAbbreviation);
      // if (this.$refs.orderType) {
      //   // this.$refs.orderType.initContratOrderType(val.code);
      this.form.currencyId = '';
      this.form.rcurrencyType ? this.form.currencyId = this.form.rcurrencyType : this.form.currencyId = 'CNY'
      this.$refs.orderType.changeTaxType(this.form);
      // }
      // if (this.$refs.rebateAmount) {
      //   this.$refs.rebateAmount.changeEndCustomer(this.form);
      // }
    },

    // 已分配金额/比例
    setUsePayMoney({rassignedAmount, ractualSettlementAmount}){
       let count = MathMulti(numDiv(rassignedAmount, ractualSettlementAmount), 100)
       return count.toFixed(2) + '%'
    }
  }
};
</script>
<style lang="scss">
.baseInfoForm {
  .el-form-item--mini.el-form-item {
    margin-bottom: 0;
  }
  .rj-col-66 {
    float: left;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 66.6666%;
  }
}
</style>
<style lang="scss">
.required {
  color: red;
  margin-left: 3px;
}

.ml-20{
  margin-left: 20px;
}
</style>
